<template>
  <v-form @submit.prevent="submit">
    <span v-if="errMsg" class="error--text">{{errMsg}}</span>
    <v-content fluid grid-list-lg v-if="isUsers" style="padding: 0;">
      <v-layout row wrap>
        <v-flex xs12 v-if="!this.pheme">
          <h3>{{this.new || copy ? 'Create' : 'Edit'}} A Non-Pheme User.</h3>
        </v-flex><v-flex md6>
          <v-text-field
            v-model="curr.profile.firstname"
            :rules="rules.name"
            :disabled="pheme"
            label="First Name"
            required
          />
        </v-flex><v-flex md6>
          <v-text-field
            v-model="curr.profile.lastname"
            :rules="rules.name"
            :disabled="pheme"
            label="Last Name"
            required
          />
        </v-flex><v-flex md6>
          <v-text-field
            v-model="curr.profile.displayname"
            :rules="rules.name"
            label="Display Name"
            required
          />
        </v-flex><v-flex md6>
          <v-text-field
            :value="pheme ? curr.username : curr.email"
            disabled
            label="User Name"
            required
          />
        </v-flex><v-flex md6>
          <v-text-field
            v-model="curr.email"
            :rules="rules.email"
            :disabled="pheme"
            label="Email"
            required
          />
        </v-flex><v-flex md6 v-if="!pheme">
          <v-text-field
            v-model="pass1"
            label="Password"
            type="password"
          />
        </v-flex><v-flex md6 v-if="!pheme">
          <v-text-field
            v-model="pass2"
            :error-messages="pass2 && pass1 !== pass2 ? 'Passwords do not match' : []"
            label="Confirm Password"
            type="password"
          />
        </v-flex><v-flex md6>
          <v-select
            v-model="curr.perm"
            :items="['student', 'staff', 'admin']"
            label="Permission"
            required
          />
        </v-flex><v-flex xs12 md6>
          <v-checkbox
            v-model="curr.invisible"
            label="Invisible (removed from supervisors list)"
          />
        </v-flex>
      </v-layout>
    </v-content>
    <v-content fluid grid-list-lg v-else style="padding: 0;">
      <v-layout row wrap align-center>
        <v-flex xs12 v-if="is(curr.name)">
          <v-text-field
            v-model="curr.name"
            :rules="rules.name"
            label="Name"
            required
          />
        </v-flex><v-flex xs12 v-if="is(curr.desc)">
          <v-textarea
            v-model="curr.desc"
            :rules="rules.desc"
            :counter="4096"
            label="Description"
          />
        </v-flex><v-flex md6 v-if="is(curr.category)">
          <v-select
            v-model="curr.category"
            :items="[
              {text: 'Normal (5 Options)', value: 'v3-Normal_5_Options'},
              {text: 'Normal (4 Options)', value: 'v3-Normal'},
              {text: 'Pass/Fail', value: 'v3-Pass/Fail'}
            ]"
            label="Category"
            required
          />
        </v-flex><v-flex xs12 md6 v-if="is(curr.inputDisabled)">
          <v-checkbox
            :disabled="/pass\/fail/i.test(curr.category)"
            :value="/pass\/fail/i.test(curr.category) || curr.inputDisabled"
            @click.stop="
              curr.inputDisabled = /pass\/fail/i.test(curr.category)
                ? curr.inputDisabled
                : !curr.inputDisabled;
            "
            label="Cannot be unchecked for a Procedure (like Pass/Fail)"
            note="click the text"
          />
        </v-flex><v-flex xs12 md6 v-if="is(curr.defaultChecked)">
          <v-checkbox
            :disabled="/pass\/fail/i.test(curr.category) || curr.inputDisabled"
            :value="/pass\/fail/i.test(curr.category) || curr.inputDisabled || curr.defaultChecked"
            @click.stop="
              curr.defaultChecked = (/pass\/fail/i.test(curr.category) || curr.inputDisabled)
                ? curr.defaultChecked
                : !curr.defaultChecked;
            "
            label="Default as checked for a Procedure"
          />
        </v-flex><v-flex xs12 v-if="is(curr.stepIds)">
          <v-autocomplete
            v-model="curr.stepIds"
            :items="stepsFind().data"
            item-text="name"
            item-value="_id"
            label="Steps"
            multiple
            chips
            clearable
            deletable-chips
            required
          />
        </v-flex><v-flex xs12 md6 v-if="is(curr.nonProcedural)">
          <v-checkbox
            v-model="curr.nonProcedural"
            label="Not a Dental Procedure"
          />
        </v-flex><v-flex xs12 md6 v-if="curr.nonProcedural && !curr.patientInfo">
          <v-checkbox
            v-model="curr.adminOnly"
            label="For Admin Use Only"
          />
        </v-flex><v-flex xs12 md6 v-if="curr.nonProcedural && !curr.adminOnly">
          <v-checkbox
            v-model="curr.patientInfo"
            label="Patient Information Still Required?"
          />
        </v-flex><v-flex xs12 v-if="is(curr.teeth) && !curr.nonProcedural">
          <v-subheader class="pl-0">Default Selected Teeth</v-subheader>
          <select-teeth
            v-model="curr.teeth"
            :rules="rules.teeth"
            label="Default Teeth"
            required
          />
        </v-flex><v-flex xs12 sm4 v-if="is(curr.unitcode)">
          <v-text-field
            v-model="curr.unitcode"
            :rules="rules.unitcode"
            label="Unit Code"
            required
          />
        </v-flex><v-flex xs12 sm4 v-if="is(curr.period)">
          <v-text-field
            v-model="curr.period"
            type="number"
            min="1"
            max="52"
            label="Teaching Period"
            required
          />
        </v-flex><v-flex xs12 sm4 v-if="is(curr.year)">
          <v-text-field
            v-model="curr.year"
            type="number"
            min="2010"
            label="Year"
            required
          />
        </v-flex><v-flex xs12 sm6 v-if="is(curr.start)">
          <datepick label="Start Date" v-model="curr.start" :form.sync="startf" :max="finishf"/>
        </v-flex><v-flex xs12 sm6 v-if="is(curr.finish)">
          <datepick label="Finish Date" v-model="curr.finish" :form.sync="finishf" :min="startf"/>
        </v-flex><v-flex v-if="is(curr.enrollment)">
          <v-autocomplete
            v-model="curr.enrollment"
            :items="usersFind({ query: { perm: 'student' } }).data"
            item-value="_id"
            label="Enrollment"
            multiple chips
            clearable deletable-chips
            required
          />
        </v-flex><v-flex v-if="is(curr.enrollment)" shrink class="bulk-wrap">
          <v-dialog v-model="bulkDialog" width="500">
            <v-btn slot="activator" color="secondary" dark>Bulk Enroll</v-btn>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                Bulk Enrollment
              </v-card-title>
              <v-card-text>
                Please enter a comma/space seperated list of users
                , it should be their pheme number
                . e.g. <code>"01010101, 12121212, 12345678"</code>
                <v-textarea v-model="bulkList" label="User List"/>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-spacer />
                <v-btn flat @click="bulkDialog = false; bulkList='';">Cancel</v-btn>
                <v-btn color="primary" flat :disabled="!bulkList" @click="bulkEnroll">
                  Process
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex><v-flex xs12 v-if="is(curr.retro)">
          <v-checkbox
            v-model="curr.manual"
            label="Allow Staff to manually apply this flag whilst grading."
          />
        </v-flex><v-flex xs12 md6 v-if="is(curr.retro)">
          <v-checkbox
            v-model="curr.retro"
            :label="
              `Retroactively apply flag (before ${moment(curr.createdAt).format('HH:mm DD/MM/YY')})`
            "
          />
        </v-flex><v-flex xs12 md3 v-if="is(curr.retro)">
          <v-text-field
            v-model="curr.colour"
            type="color"
            class="input-group--dirty"
            label="Colour"
          />
        </v-flex><v-flex xs12 md3 v-if="is(curr.visibleTo)">
          <v-select
            v-model="curr.visibleTo"
            label="Visible to"
            :items="[
              { value: 'student', text: 'Student and up' },
              { value: 'staff', text: 'Staff and up' },
              { value: 'admin', text: 'Admin only' },
            ]"
          />
        </v-flex><v-flex xs12 v-if="is(curr.notify)">
          <v-autocomplete
            v-model="curr.notify"
            :items="usersFind({ query: { $sort: { name: 1 } } }).data"
            item-value="_id"
            label="Send notifications to:"
            multiple chips
            clearable deletable-chips
          />
        </v-flex><v-flex xs12 v-if="is(curr.match)">
          <span class="subheading">Filters:</span>
          <attempt-filter
            :query="JSON.parse(curr.match)"
            @update:query="curr.match = JSON.stringify($event)"
            :dates="false"
          />
        </v-flex>
      </v-layout>
    </v-content>
    <v-btn color="primary" @click.stop="submit">{{this.new||this.copy?'Create':'Save'}}</v-btn>
    <v-dialog v-model="bulkDialog" width="500" v-if="isUsers && this.new">
      <v-btn slot="activator" color="secondary" dark>Create Pheme Users</v-btn>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Create Pheme Users
        </v-card-title>
        <v-card-text>
          <p v-if="bulkMsg" :class="bulkClass">{{bulkMsg}}</p>
          <p>
          Please enter a comma/space seperated list of users
          , it should be their pheme number
          . e.g. <code>"01010101, 12121212, 12345678"</code>
          </p>
          <v-switch v-model="detectStaff" label="Give staff numbers staff permission?"/>
          <v-textarea v-model="bulkList" label="User List" @keyup="bulkMsg=''"/>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="bulkDialog = false; bulkList='';">Cancel</v-btn>
          <v-btn color="primary" flat :disabled="!bulkList" @click="bulkCreate">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" top multi-line :timeout="5000">
      <span class="success--text">Saved {{curr.name}}!</span>
      <v-btn color="pink" flat icon @click="success = false">
        <v-icon>far fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import attemptFilter from '../attempt-filter.vue';
import datepick from '../datepick.vue';
import selectTeeth from '../select-teeth.vue';

export default {
  components: {
    datepick,
    selectTeeth,
    attemptFilter,
  },
  props: {
    service: {
      type: String,
      default: 'users',
    },
    current: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      moment,
      rules: {
        name: [v => /^.{1,255}$/.test(v) || 'Invalid name provided.'],
        email: [v => /^.+@.+[.].+$/.test(v) || 'Invalid email provided.'],
        desc: [v => /^.{0,1023}$/.test(v) || 'Invalid description provided.'],
        unitcode: [v => /^.{8,12}$/.test(v) || 'Invalid unitcode provided.'],
      },
      pass1: '',
      pass2: '',
      success: false,
      startf: '',
      finishf: '',
      bulkDialog: false,
      bulkList: '',
      bulkMsg: '',
      bulkClass: '',
      detectStaff: false,
      // email: this.current.email,
      curr: { profile: {} },
      errMsg: '',
      match: {},
    };
  },
  computed: {
    ...mapGetters('steps', { stepsFind: 'find' }),
    ...mapGetters('users', { usersFind: 'find' }),
    isUsers() { return this.service === 'users'; },
    pheme() { return this.isUsers && /^\d{8}$/.test(this.curr.username); },
    copy() { return typeof this.$route.query.copy !== 'undefined'; },
    new() { return this.$route.params.id === 'new'; },
  },
  methods: {
    is(v) { return typeof v !== 'undefined'; },
    log(v) { console.log(v); },
    async submit() {
      this.errMsg = '';
      if (this.isUsers && !this.pheme) {
        if (this.pass1) {
          if (this.pass1 !== this.pass2) return;
          this.curr.password = this.pass1;
        }
        this.curr.username = this.curr.email;
      }
      try {
        const res = await this.curr.save();
        this.success = true;
        this.pass1 = '';
        this.pass2 = '';
        delete this.curr.password;
        if (this.new || this.copy) {
          this.$router.push(`/admin/${this.service}/${res._id}`);
        }
      } catch (err) {
        console.error(err);
        this.errMsg = err.message;
      }
    },
    bulkEnroll() {
      const usernames = this.bulkList.replace(/[^\d\s,]/g, '').split(/[\s,]+/g);
      const users = this.usersFind({ query: { username: { $in: usernames } } }).data;
      users.forEach((u) => {
        if (this.curr.enrollment.indexOf(u._id) === -1) this.curr.enrollment.push(u._id);
      });
      this.bulkList = '';
      this.bulkDialog = false;
    },
    async bulkCreate() {
      const { User } = this.$FeathersVuex;
      const usernames = this.bulkList
        .replace(/[^\d\s,]/g, '')
        .split(/[\s,]+/g)
        .filter(un => /^\d{8}$/.test(un));
      try {
        await Promise.all(usernames.map(async (username) => {
          const isStaff = /^0{1,3}/.test(username);
          const user = new User({
            username,
            email: isStaff ? `pending.${username}@uwa.edu.au` : `${username}@student.uwa.edu.au`,
            profile: {
              firstname: 'Details Pending',
              lastname: 'Initial Login',
            },
            perm: this.detectStaff && isStaff ? 'staff' : 'student',
          });
          await user.save();
          return user;
        }));
        this.bulkMsg = `Success, added the following users: ${usernames.join(', ')}.`;
        this.bulkClass = 'success--text';
        this.bulkList = '';
      } catch (err) {
        this.bulkMsg = `An Error occured: ${err.message}`;
        this.bulkClass = 'error--text';
      }
    },
  },
  mounted() {
    // this.email = this.curr.email;
    this.curr = cloneDeep(this.current);
  },
  watch: {
    current() { this.curr = cloneDeep(this.current); },
    curr() {
      if (!isEqual(this.curr, cloneDeep(this.current))) this.$emit('update:current', this.curr);
    },
    // email() {
    //   this.curr.email = this.email;
    //   if (!this.pheme) this.curr.username = this.email;
    // },
  },
};
</script>

<style lang="stylus" scoped>
.bulk-wrap
  display flex
  align-items center
.input-group--dirty
  width: 3em;
  >>> input
    padding: 0;
</style>
